import React, { Fragment } from "react";
import { NoRecordsBanner } from '../OopsBanner';
import { GetStoredRenterImage } from "./RenderBusinessOwnerName";

export default function RenderBusinessLogo({ data, layout = "1" }: { data: any, layout: string }) {

    let renterImage = GetStoredRenterImage();
    let useRenterImage = layout=="1" && renterImage.length>0;
    if (data?.isStenciled&&!useRenterImage ) {

        return <div className="stenciled  flex-column gap-small h-full w-full">
            <div className='w-full h-full stencil-item' ></div>
        </div>
    }


    else if (!data || data.length == 0||data?.response=="No Record Found")
        return null;
    let img = (useRenterImage? renterImage : data);


    switch (layout) {
        default:
            return (<Fragment>
                <div className={"w-full h-full flex-column gap-small " + (data.isStenciled ? "stenciled" : "")}>
                    <span className="w-full h-full stencil-item no-a fixed-image-dimension" style={{ display: "block", backgroundImage: `url(${img})`, backgroundPosition: "center", backgroundSize: "cover" }}></span>
                </div>
            </Fragment >
            )
    }
}
